 
import { Component, Vue } from 'vue-property-decorator';
 const $ = require('jquery');

export default class toaster extends Vue {
        
    
}
